import React, {Component} from 'react';


class Loader extends Component {

    render() {
        return (
            <div style={{textAlign: 'center'}}>
                <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"
                     stroke="#ae4d">
                    <g fill="none" fillRule="evenodd" strokeWidth="4">
                        <circle cx="22" cy="22" r="1">
                            <animate attributeName="r"
                                     begin="0s" dur="1.8s"
                                     values="1; 20"
                                     calcMode="spline"
                                     keyTimes="0; 1"
                                     keySplines="0.165, 0.84, 0.44, 1"
                                     repeatCount="indefinite"/>
                            <animate attributeName="stroke-opacity"
                                     begin="0s" dur="1.8s"
                                     values="1; 0"
                                     calcMode="spline"
                                     keyTimes="0; 1"
                                     keySplines="0.3, 0.61, 0.355, 1"
                                     repeatCount="indefinite"/>
                        </circle>
                        <circle cx="22" cy="22" r="1">
                            <animate attributeName="r"
                                     begin="-0.9s" dur="1.8s"
                                     values="1; 20"
                                     calcMode="spline"
                                     keyTimes="0; 1"
                                     keySplines="0.165, 0.84, 0.44, 1"
                                     repeatCount="indefinite"/>
                            <animate attributeName="stroke-opacity"
                                     begin="-0.9s" dur="1.8s"
                                     values="1; 0"
                                     calcMode="spline"
                                     keyTimes="0; 1"
                                     keySplines="0.3, 0.61, 0.355, 1"
                                     repeatCount="indefinite"/>
                        </circle>
                    </g>
                </svg>

            </div>
        )
    }

}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js